import { render, staticRenderFns } from "./OrderProductTableColumn.vue?vue&type=template&id=d04a6776&scoped=true"
import script from "./OrderProductTableColumn.vue?vue&type=script&lang=js"
export * from "./OrderProductTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04a6776",
  null
  
)

export default component.exports